<template> 
   <div class="main_header_outer">
      <div class="main_header_comment clear">
        <div class="tit" v-html="title">  
        </div>
        <div class="main_header_count clear">
          <ul>
            <!-- <li @click="refreshCooperation" style="cursor:pointer;">
                <b>{{totalBoardCount}}</b>
                <span>전체 보드 수</span>
            </li> -->
            <li @click="noneReadCooperation" style="cursor:pointer;">
                <b>{{cfrcNoneReadCount > 999 ? '999+' : cfrcNoneReadCount}}</b>
                <span>{{ $i18nUtil.trans("button.cooperation.unread","미확인") }}</span>
            </li>
          </ul>
          <!-- <CooperationHeader
            :categoryList="categoryList"
            :boardListCount="boardListCount"
          /> -->
        </div>
      </div>
    </div> 
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
export default {
  /* props: ["categoryList", "boardListCount", ], */
  props: ["type"],
  data() {
    return {
      boardListCount: null,
      title: this.$i18nUtil.trans("message.CooperationHeader.001","회의/협의 공간에서 <br /><b>최근 일주일간 업데이트된 내용</b>을 확인해보세요"),
    };
  },
  mounted() {
    //this.getPaperCount(); 
  }, 
  computed:{
    ...mapState("shareInfo", ["cfrcNoneReadCount"]),
  },
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    noneReadCooperation(){
      this.$emit("noneReadCooperation");
    },
    setType(data){ 
      if(data==="ALL"){
        this.title= this.$i18nUtil.trans("message.CooperationHeader.001","회의/협의 공간에서 <br /><b>최근 일주일간 업데이트된 내용</b>을 확인해보세요");
      }else{
        this.title= this.$i18nUtil.trans("message.CooperationHeader.002","회의의 내용을 <br /><b>협의할 수 있는 공간</b>입니다.");
      }
    }
    // getPaperCount() {
    //   let obj = this;
    //   let categoryMid = obj.category.categoryMid;
    //   let reqData = {
    //     url: "/api/copaper/paper/getCfrcPaperCount",
    //     method: "post",
    //     params: { categoryMid: categoryMid }
    //   };
    //   obj
    //     .COWORK_REST_SIMPLE_ACTION(reqData)
    //     .then(function(res) {
    //       obj.boardListCount = res.result;
    //     })
    //     .catch(function(err) {
    //       console.log(err);
    //     });
    // }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/cowork/general/cooperation/base/CooperationHeader.vue